import type { RegionOption } from '../region-select-modal';

const MCP_PATH = '/api/unstable/mcp-server/mcp';

/** Datadog MCP endpoints per site. See https://docs.datadoghq.com/bits_ai/mcp_server/setup/ */
export const DATADOG_SITE_OPTIONS = [
  {
    value: 'us1',
    label: 'US1',
    description: 'app.datadoghq.com',
    mcpUrl: `https://mcp.datadoghq.com${MCP_PATH}`,
  },
  {
    value: 'us3',
    label: 'US3',
    description: 'us3.datadoghq.com',
    mcpUrl: `https://mcp.us3.datadoghq.com${MCP_PATH}`,
  },
  {
    value: 'us5',
    label: 'US5',
    description: 'us5.datadoghq.com',
    mcpUrl: `https://mcp.us5.datadoghq.com${MCP_PATH}`,
  },
  {
    value: 'eu1',
    label: 'EU1',
    description: 'app.datadoghq.eu',
    mcpUrl: `https://mcp.datadoghq.eu${MCP_PATH}`,
  },
  {
    value: 'ap1',
    label: 'AP1',
    description: 'ap1.datadoghq.com',
    mcpUrl: `https://mcp.ap1.datadoghq.com${MCP_PATH}`,
  },
  {
    value: 'ap2',
    label: 'AP2',
    description: 'ap2.datadoghq.com',
    mcpUrl: `https://mcp.ap2.datadoghq.com${MCP_PATH}`,
  },
] as const satisfies readonly RegionOption[];

export function isDatadogMcpUrl(url: string): boolean {
  return /^https:\/\/mcp\.([a-z0-9]+\.)?datadoghq\.(com|eu)\//i.test(url);
}
